import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Divider,
  Button,
  Input,
  Comment,
  message,
  Form,
  Icon,
} from 'antd';

import {
  formatCell,
  sorter,
  createColumns
} from '../../../helpers';

import DataTable from '../../DataTable';
import {
  Dialog,
  Spinner,
} from '../../UI';

import styles from './Closed.module.css';

const { Title } = Typography;
const { TextArea } = Input;

message.config({
  top: 12,
  duration: 3
});

const Editor = ({ onChange, submitting, onSubmit, value }) => {
  return (
    <div>
      <Form.Item className={styles['form-item-wrapper']}>
        <TextArea
          rows={4}
          onChange={onChange}
          value={value}
          name="value"
        />
      </Form.Item>
      <Form.Item className={styles['form-item-wrapper']}>
        <Button
          loading={submitting}
          htmlType="submit"
          onClick={onSubmit}
          type="primary"
        >
          Add Message
        </Button>
      </Form.Item>
    </div>
  );
};

const NewTicket = ({ onSubmit, onChange, subject, message }) => {
  return (
    <div>
      <Form.Item className="form-item-wrapper" label="Subject">
        <Input
          onChange={onChange}
          value={subject}
          name="subject"
        />
      </Form.Item>
      <Form.Item className="form-item-wrapper" label="Message">
        <TextArea
          onChange={onChange}
          value={message}
          name="message"
        />
      </Form.Item>
    </div>
  );
};

class Closed extends PureComponent {
  state = {
    show: false,
    create: false,
    timeZone: '',
    subject: '',
    message: '',
    ticketId: '',
    ticketDetails: [],
    submitting: false,
    searchText: '',
  };

  componentDidMount () {
    this.props.fetchUserInfo(() => {
      const payload = {
        timeZone: this.props.user.time_zone,
      };

      this.setState({
        timeZone: payload.timeZone
      });

      this.props.fetchTicketsClosed(payload);
    });
  };

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{padding: 8}}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder="Search in column"
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{
            width: 188,
            marginBottom: 8,
            display: 'block'
          }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{width: 90, marginRight: 8}}
        >
          Search
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{width: 90}}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      dataIndex === 'details'
        ? <Icon type="search" style={{ display: 'none' }} />
        : <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      return record[dataIndex].toString().toLowerCase().indexOf(value.toString()) > -1;
    },
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    }
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  success = (msg) => {
    message.success(msg);
  };

  open = (event, modal, cb) => {
    const modalId = modal;
    const { rowid } = event.target.dataset;

    this.setState({
      [modalId] : !!modalId
    });

    rowid ? cb(rowid) : cb();
  };

  close = () => {
    this.setState({
      show: false,
      create: false,
      ticketDetails: [],
      subject: '',
      message: '',
    });
  };

  details = (rowid) => {
    const {
      id: ticketId,
      subject
    } = this.props.ticketsClosed.data[rowid];

    this.setState({
      ticketId,
      subject
    });

    const payload = {
      timeZone: this.state.timeZone,
      ticketId
    };

    this.props.fetchTicketDetails(payload, () => {
      this.setState({
        ticketDetails: this.props.ticketDetails
      });
    });
  };

  handleMessage = () => {
    if (!this.state.value) {
      return;
    }

    this.setState({
      submitting: true,
    });

    setTimeout(() => {
      const newMessage = {
        message: this.state.value,
        ticketId: this.state.ticketId
      };

      this.props.addTicketMessage(newMessage, () => {
        const payload = {
          timeZone: this.state.timeZone,
          ticketId: this.state.ticketId,
        };

        this.props.fetchTicketDetails(payload, () => {
          this.setState({
            value: '',
            ticketDetails: this.props.ticketDetails,
            submitting: false,
          });
        });

      });
    }, 800);
  };

  handleSubmit = () => {
    if (!this.state.subject || !this.state.message) {
      return;
    }

    const payload = {
      subject: this.state.subject,
      message: this.state.message
    };

    this.props.createTicket(payload, () => {
      this.close();
      const payload = {
        timeZone: this.state.timeZone,
      };

      this.props.fetchTicketsClosed(payload, () => {
        this.setState({
          subject: '',
          message: '',
        });

        if (!this.state.create) {
          setTimeout(() => this.success(`Ticket was created`), 500);
        }
      });
    });
  };

  handleChange = (event) => {
    const { value, name } = event.target;

    this.setState({
      [name]: value
    });
  };

  closeTicket = (event) => {
    event.preventDefault();
    const payload = {
      ticketId: this.state.ticketId
    };

    this.props.closeTicket(payload, () => {
      const payload = {
        timeZone: this.props.user.time_zone,
      };

      this.props.fetchTicketsClosed(payload, () => {
        this.setState({
          ticketDetails: this.props.ticketDetails,
          show: false,
        });

        if (!this.state.show) {
          setTimeout(() => this.success(`Ticket ${this.state.ticketId} was closed`), 500);
        }
      });
    });
  };

  scrollToBottom() {
    this.el.scrollIntoView({ behavior: 'smooth' });
  }

  render() {
    const {
      pageLoading,
      loading,
      ticketsClosed,
      ticketsClosed: {
        fields,
        tableName,
      }
    } = this.props;
    const {
      show,
      create,
      ticketDetails,
      value,
      subject,
      message,
      submitting,
    } = this.state;
    const fieldsObj = fields && fields[0];

    const renderTableCell = (text, record, item) => {
      const { rowId } = record;
      let content = text;
      if (item.button !== undefined) {
        if (item.button.type === 'link') {
          content = (
            <Button
              type="link"
              className={styles['edit-btn']}
              data-rowid={rowId}
              onClick={(event) => this.open(event, 'show', this.details)}
              name={item.button.id}
            >
              Show
            </Button>
          );
        }
      }

      return formatCell(item, content);
    };

    const columns = createColumns(
      fieldsObj,
      sorter,
      renderTableCell,
      this.getColumnSearchProps,
    );

    let content = <Spinner />;
    if (!pageLoading) {
      content = (
        <>
          <Divider />
          <DataTable
            loading={loading}
            table={{
              columns: columns,
              data: ticketsClosed,
              tableName: tableName,
              toolbar: {
                titleExport: 'Tickets Closed Export',
              },
              pagination: true
            }}
            rowClassName={(record) => record.isNew === '1' ? 'row-not-read' : ''}
          />
        </>
      )
    }

    const details = (
      this.props.messageLoading ? (
        <Spinner />
      ) : (
        <>
          {ticketDetails.length > 0 && ticketDetails.map(({ rowId, datestamp, msg_text, msg_type }) => (
            msg_type === '1' ? (
              <Comment
                className="ant-comment-you"
                key={rowId}
                author={
                  <div className="ant-comment-header">
                    <div className="ant-comment-header-title">You</div>
                    <small>{datestamp}</small>
                  </div>
                }
                content={
                  <div>
                    <p>{msg_text}</p>
                  </div>
                }
              />
            ) : (
              <Comment
                className="ant-comment-support"
                key={rowId}
                author={
                  <div className="ant-comment-header">
                    <div className="ant-comment-header-title">Support</div>
                    <small>{datestamp}</small>
                  </div>
                }
                content={
                  <div>
                    <p>{msg_text}</p>
                  </div>
                }
              />
            )
          ))}
          <Comment
            className="editor-comment"
            avatar={false}
            content={
              <Editor
                onChange={this.handleChange}
                onSubmit={this.handleMessage}
                value={value}
                submitting={submitting}
                closeTicket={this.closeTicket}
              />
            }
          />
        </>
      )
    );

    const ticket = (
      this.props.loading ? (
        <Spinner />
      ) : (
        <NewTicket
          onChange={this.handleChange}
          subject={subject}
          message={message}
        />
      )
    );

    return (
      <div>
        <Title>Closed</Title>
        {content}

        <Dialog
          title={`Details for ticket: ${subject}`}
          visible={show}
          onOk={this.close}
          onCancel={this.close}
          content={details}
          hideCancel
          width={1170}
          containerClass="scroll-body"
          hasScroll
        />

        <Dialog
          title="Create Ticket"
          visible={create}
          onOk={this.handleSubmit}
          onCancel={this.close}
          content={ticket}
        />
      </div>
    );
  }
}

Closed.propTypes = {
  pageLoading: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  fetchUserInfo: PropTypes.func.isRequired,
  fetchTicketsClosed: PropTypes.func.isRequired,
  createTicket: PropTypes.func.isRequired
};

Closed.defaultProps = {
  paymentsDetails: {}
};

export default Closed = Form.create({})(Closed)
